import React from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';

const PMSAdminRecordSubject = () => {
    return (
        <div>
   <NavigationBar/>
   pmsadminrecordsubject 
        </div>
    );
};

export default PMSAdminRecordSubject;